
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M12 5.10001V9.15001L19.4 16.55C20.55 13.67 19.99 10.27 17.65 7.94001L12.71 2.99001C12.32 2.60001 11.69 2.60001 11.3 2.99001L8.55996 5.71001L9.96996 7.12001L12 5.10001ZM3.68996 5.08001C3.29996 5.47001 3.29996 6.10001 3.68996 6.49001L5.76996 8.57001C3.22996 11.71 3.41996 16.32 6.33996 19.25C7.89996 20.8 9.94996 21.58 12 21.58C13.78 21.58 15.56 20.99 17.02 19.81L19.02 21.81C19.41 22.2 20.04 22.2 20.43 21.81C20.82 21.42 20.82 20.79 20.43 20.4L5.10996 5.08001C4.71996 4.69001 4.07996 4.69001 3.68996 5.08001ZM12 19.59C10.4 19.59 8.88996 18.97 7.75996 17.83C6.61996 16.69 5.99996 15.19 5.99996 13.59C5.99996 12.27 6.42996 11.03 7.20996 10L12 14.79V19.59Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-invert-colors-off`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconInvertColorsOff

    ```js
    <b-new-b-icon-invert-colors-off />
    ```
</docs>


